import { Card } from '../components/Card';
import { MetricRow } from '../components/MetricRow';
import { ScoreRing } from '../components/ScoreRing';
import { useHealthData } from '../services/HealthDataContext';
import { getMetricSeries } from '../services/metrics';
import { formatTime } from '../services/labels';

const WORKOUT_TYPE_LABELS: Record<string, string> = {
  strength_training: 'Entrenamiento de fuerza',
  running: 'Carrera',
};

export function ActivityScreen() {
  const { today, todayKey, scores, baselines, historyByDate } = useHealthData();

  const series = (metric: Parameters<typeof getMetricSeries>[1]) =>
    getMetricSeries(historyByDate, metric, todayKey, 14).map((point) => point.value);

  return (
    <div className="screen screen--activity">
      <div className="screen__score-header">
        <ScoreRing score={scores.activityScore} label="Actividad" size={140} />
        <div className="screen__score-summary">
          <p className="screen__score-summary-title">{today.activity.steps.toLocaleString('es-ES')} pasos</p>
          <p className="screen__score-summary-subtitle">{today.activity.exerciseMinutes} min de ejercicio</p>
        </div>
      </div>

      <Card title="Actividad de hoy" subtitle="Comparada con tu baseline personal">
        <div className="metric-grid">
          <MetricRow
            label="Pasos"
            value={today.activity.steps.toLocaleString('es-ES')}
            baseline={baselines.metrics.steps?.[30]}
            series={series('steps')}
          />
          <MetricRow
            label="Calorias activas"
            value={String(today.activity.activeCalories)}
            unit="kcal"
            baseline={baselines.metrics.activeCalories?.[30]}
            series={series('activeCalories')}
          />
          <MetricRow
            label="Minutos de ejercicio"
            value={String(today.activity.exerciseMinutes)}
            unit="min"
            baseline={baselines.metrics.exerciseMinutes?.[30]}
            series={series('exerciseMinutes')}
          />
          <MetricRow label="Distancia" value={today.activity.distanceKm.toFixed(1)} unit="km" hideBaseline />
        </div>
      </Card>

      <Card title="Entrenamientos">
        {today.activity.workouts.length === 0 ? (
          <p className="empty-state">Sin entrenamientos registrados hoy.</p>
        ) : (
          <ul className="workout-list">
            {today.activity.workouts.map((workout) => (
              <li key={workout.id} className="workout-list__item">
                <div>
                  <p className="workout-list__type">{WORKOUT_TYPE_LABELS[workout.type] ?? workout.type}</p>
                  <p className="workout-list__time">
                    {formatTime(workout.startTime)} - {formatTime(workout.endTime)}
                  </p>
                </div>
                <div className="workout-list__stats">
                  <span>{workout.durationMinutes} min</span>
                  <span>{workout.activeCalories} kcal</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
